<template>
  <div class="collapse" :style="{ maxHeight }" :class="{'is-free': isFree}">
    <div class="inner" ref="inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Collapse',
  data() {
    return {
      innerHeight: 0,
      isFree: false,
      maxHeight: 0,
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxHeightProxy() {
      return this.isOpen ? `${this.innerHeight}px` : '0'
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) {
          this.updateInnerHeight()
          this.isFree = false
          this.$nextTick(() => this.maxHeight = this.maxHeightProxy)
          setTimeout(() => this.isFree = true, 300)
        } else {
          this.updateInnerHeight()
          this.isFree = false
          setTimeout(() => this.maxHeight = 0)
        }
      },
    },
  },
  methods: {
    updateInnerHeight() {
      this.$nextTick(()=> {
        this.innerHeight = this.$refs.inner.clientHeight
      })
    }
  },
}
</script>

<style scoped lang="scss">
.collapse {
  overflow: hidden;
  transition: max-height 0.3s ease;

  &.is-free {
    max-height: unset!important;
  }
}
</style>
